import React, { Component, Fragment, PureComponent } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/Actions/actions";
import Popup from "../../Modal/Popup";
import * as UTILS from "../../../utils/Utils";
import Library from "../../Modal/Library/Library";
import cloneDeep from "lodash.clonedeep";
import ImageSetting from "./SettingModal";
import CloneICON from "../../../assets/images/clone.svg";
import AddPlus from "../../../assets/images/add_image.svg";
import AddPlusActive from "../../../assets/images/add_image_active.svg";
import "./Image.scss";
import RangeInputSlider from "../../Tool/RangeSlider";
import noImage from '../../../assets/images/noimage.png'

class Image extends Component {
  constructor(props) {
    super(props);
    this.widthInput = React.createRef();
    this.state = {
      clickedImageID: null,
      imageLibrary: false,
      opacity: this.props.opacity || 1,
      id: null,
      enableContentModal: false,
      linkOptionOpen: false,
      loading: false,
      resizeWidth: false,
      maxWidthRange: this.props.containerWidth,
    };
  }

  addImage = (elementID) => {
    this.setState({
      clickedImageID: elementID,
      id: null,
    });
  };
  changeImage = (elementID) => {
    this.setState({
      clickedImageID: elementID,
      id: null,
    });
  };

  setIdForEditHandler = (editID) => {
    this.setState({
      id: editID,
    });
  };
  toggleUploadPopup = () => {
    this.setState({
      clickedImageID: null,
    });
  };

  enableModal = (e) => {
    this.setState(
      {
        enableContentModal: true,
      },
      () => {
        let contentModalDiv = document.querySelector("body .contentModal");
        !contentModalDiv && document.body.classList.contains("my-class-name")
          ? null
          : (document.body.className += " contentModalEnabled");
      }
    );
  };
  counterChange = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue =
      e.target.value !== "" && e.target.value !== "0" && e.target.value !== "00"
        ? e.target.value.replace(/\b0+/g, "")
        : "0";

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = selectedValue;
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  counterPlus = (value, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = JSON.stringify(JSON.parse(selectedValue) + 1);
      },
      (colItem) => {
        colItem.style[property] = JSON.stringify(JSON.parse(selectedValue) + 1);
      },
      (colItemNested) => {
        colItemNested.style[property] = JSON.stringify(
          JSON.parse(selectedValue) + 1
        );
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  counterMinus = (value, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = value > 1 ? value : "1";
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = JSON.stringify(JSON.parse(selectedValue) - 1);
      },
      (colItem) => {
        colItem.style[property] = JSON.stringify(JSON.parse(selectedValue) - 1);
      },
      (colItemNested) => {
        colItemNested.style[property] = JSON.stringify(
          JSON.parse(selectedValue) - 1
        );
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  rangeWidthSlider = (width) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue =
      width !== "" && width !== "0" && width !== "00"
        ? width.replace(/\b0+/g, "")
        : "0";

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style.maxWidth = selectedValue;
        item.style.height = "auto";
        item.style.imageWidthUnit = "px";
      },
      (colItem) => {
        colItem.style.maxWidth = selectedValue;
        colItem.style.height = "auto";
        colItem.style.imageWidthUnit = "px";
      },
      (colItemNested) => {
        colItemNested.style.maxWidth = selectedValue;
        colItemNested.style.height = "auto";
        colItemNested.style.imageWidthUnit = "px";
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  rangeHeightSlider = (height) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue =
      height !== "" && height !== "0" && height !== "00"
        ? height.replace(/\b0+/g, "")
        : "0";

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style.height = selectedValue;
        item.style.maxWidth = "auto";
      },
      (colItem) => {
        colItem.style.height = selectedValue;
        colItem.style.maxWidth = "auto";
      },
      (colItemNested) => {
        colItemNested.style.height = selectedValue;
        colItemNested.style.maxWidth = "auto";
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  closeModal = () => {
    this.setState(
      {
        enableContentModal: false,
      },
      () => {
        document.body.classList.remove("contentModalEnabled");
      }
    );
  };
  widthToggle = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = e.target.checked == true ? "" : "auto";

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = selectedValue;
        item.style.imageWidthUnit = e.target.checked == false ? "px" : "%";
        // item.style.objectFit = (e.target.checked == false ? 'scale-down':'unset');
        item.style.height = "auto";
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
        colItem.style.imageWidthUnit = e.target.checked == false ? "px" : "%";
        // colItem.style.objectFit = (e.target.checked == false ? 'scale-down':'unset');
        colItem.style.height = "auto";
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
        colItemNested.style.imageWidthUnit =
          e.target.checked == false ? "px" : "%";
        // colItemNested.style.objectFit = (e.target.checked == false ? 'scale-down':'unset');
        colItemNested.style.height = "auto";
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  unitWidthValueChange = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = e.target.value;

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = selectedValue;
        item.style.maxWidth = e.target.value == "%" ? "100" : "400";
        item.style.height = e.target.value == "%" ? "auto" : "400";
        // item.style.objectFit = e.target.value == "%" ? "unset":"scale-down";
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
        colItem.style.maxWidth = e.target.value == "%" ? "100" : "400";
        colItem.style.height = e.target.value == "%" ? "auto" : "400";
        // colItem.style.objectFit = e.target.value == "%" ? "unset":"scale-down";
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
        colItemNested.style.maxWidth = e.target.value == "%" ? "100" : "400";
        colItemNested.style.height = e.target.value == "%" ? "auto" : "400";
        // colItemNested.style.objectFit = e.target.value == "%" ? "unset":"scale-down";
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  // Height CONTROLS
  shouldComponentUpdate = (nextProps, nextState) => {
    if (
      nextProps.src !== this.props.src ||
      nextProps.width !== this.props.width ||
      nextProps.height !== this.props.height ||
      nextProps.opacity !== this.props.opacity ||
      nextState.clickedImageID !== this.state.clickedImageID ||
      nextState.resizeWidth !== this.state.resizeWidth ||
      nextState.linkOptionOpen !== this.state.linkOptionOpen ||
      nextProps.float !== this.props.float ||
      nextProps.mobileAlign !== this.props.mobileAlign ||
      nextProps.mobileView !== this.props.mobileView ||
      nextProps.radius !== this.props.radius ||
      nextProps.imageMarginUnit !== this.props.imageMarginUnit ||
      nextProps.marginTop !== this.props.marginTop ||
      nextProps.marginBottom !== this.props.marginBottom ||
      nextState.enableContentModal !== this.state.enableContentModal ||
      nextState.id !== this.state.id ||
      nextState.imageLibrary !== this.state.imageLibrary ||
      nextProps.element !== this.props.element
    ) {
      return true;
    }
    return false;
  };
  render() {
    return (
      <div
        className="image-wrapper"
        style={
          !this.props.mobileView ? {
            justifyContent:
              this.props.float == "left" ? "left" : this.props.float == 'right' ? "right" : "center"
          } : {
            justifyContent:
              this.props.mobileAlign == "left" ? "left" : this.props.mobileAlign == 'right' ? "right" : "center"

          }}
      >
        {!this.props.element.dataModule && (
          <div className="actionControl">
            <span
              onClick={() => this.setIdForEditHandler(this.props.ID)}
              className="image-setting"
            >
              Image Settings
            </span>
            <button className="clone-item" onClick={() => { this.props.cloneElement(this.props.element.id) }}>
              <img src={CloneICON} />
            </button>
            <span className="delete-item" onClick={() => { this.props.deleteElement(this.props.element.id) }}>
              <i className="far fa-trash-alt" />
            </span>
          </div>
        )}
        {this.props.src !== null ? (
          <div>
            <img
              onError={(e) => {
                e.target.src = noImage;
              }}
              className={this.state.enableContentModal ? " activeElement" : " "}
              onClick={this.props.element.dataModule ? this.enableModal : null}
              id="main"
              src={this.props.src}
              style={{
                // objectFit:this.props.style.objectFit ? this.props.style.objectFit:'unset',
                height:
                  this.props.height &&
                    this.props.height !== "auto" &&
                    this.props.imageWidthUnit !== "%"
                    ? this.props.height + "px"
                    : this.props.height && this.props.height == "auto"
                      ? "auto"
                      : "100%",
                maxWidth: "100%", // OLD parameter is in maxWidth but applied in width
                width:
                  this.props.width !== "" && this.props.width !== "auto"
                    ? this.props.width +
                    (this.props.imageWidthUnit
                      ? this.props.imageWidthUnit
                      : "px")
                    : this.props.width == "auto"
                      ? "auto"
                      : this.props.imageWidthUnit == "%" && this.props.width == ""
                        ? "100%"
                        : "100%",
                borderRadius: this.props.radius + "px",
                opacity: this.props.opacity,
                marginTop:
                  this.props.marginTop +
                  (this.props.imageMarginUnit
                    ? this.props.imageMarginUnit
                    : "px"),
                marginLeft:
                  this.props.marginLeft +
                  (this.props.imageMarginUnit
                    ? this.props.imageMarginUnit
                    : "px"),
                marginBottom:
                  this.props.marginBottom +
                  (this.props.imageMarginUnit
                    ? this.props.imageMarginUnit
                    : "px"),
                marginRight:
                  this.props.marginRight +
                  (this.props.imageMarginUnit
                    ? this.props.imageMarginUnit
                    : "px"),
              }}
            />
          </div>
        ) : (
          <div
            className={
              "addImageHolder" + (this.props.src ? " " : " ")
            }
          >
            <button
              onClick={() => {
                this.addImage(this.props.ID);
              }}
            >
              <img className="normal" src={AddPlus} />
              <img className="active" src={AddPlusActive} />
            </button>
            <span>Add Image</span>
          </div>
        )}

        {this.props.ID === this.state.id && (
          <Popup
            width="700"
            header="Image Settings"
            parentID="imageSetting"
            closePopup={() => this.setIdForEditHandler(null)}
            close={() => this.setIdForEditHandler(null)}
          >
            <ImageSetting
              mobileAlign={this.props.mobileAlign}
              pagesList={this.props.pagesList}
              userID={this.props.userID}
              sessionID={this.props.sessionID}
              Link={this.props.Link}
              LinkName={this.props.LinkName}
              LinkType={this.props.LinkType}
              LinkOpen={this.props.LinkOpen}
              imageMarginUnit={this.props.imageMarginUnit}
              marginTop={this.props.marginTop || 0}
              marginRight={this.props.marginRight || 0}
              marginBottom={this.props.marginBottom || 0}
              marginLeft={this.props.marginLeft || 0}
              UseSocial={this.props.UseSocial}
              float={this.props.float}
              opacity={this.state.opacity}
              ID={this.props.ID}
              changeImage={() => {
                this.changeImage(this.props.ID);
              }}
              label={this.props.label}
              radius={this.props.radius}
              width={this.props.width}
              URL={this.props.URL}
              closePopup={() => this.setIdForEditHandler(null)}
              src={this.props.src}
            >
              <div className=" widthSlideRange" style={{ width: "100%" }}>
                {this.props.imageWidthUnit !== "%" && (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label>
                      Image Width
                      <div style={{ width: "100px", float: "right" }}>

                      </div>
                    </label>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                      }}
                    >
                      <div style={{ width: "120%" }}>
                        <RangeInputSlider
                          onChangeHandler={(widthVal) => {
                            this.rangeWidthSlider(widthVal);
                          }}
                          widthValue={
                            this.props.width == "auto" || this.props.width == ""
                              ? 0
                              : this.props.width
                          }
                          maxWidthRange={1200}
                        />
                      </div>
                      <span className="widthRangeLabel">
                        <input
                          onChange={(e) => {
                            UTILS.ValidateIfValueNumber(e.target.value) &&
                              (this.props.imageWidthUnit == "%"
                                ? e.target.value < 100
                                : e.target.value)
                              ? this.counterChange(e, "maxWidth")
                              : null;
                          }}
                          value={
                            this.props.width == "auto"
                              ? "auto"
                              : this.props.width
                          }
                          type="text"
                        />
                      </span>
                    </div>
                  </div>
                )}

                {/* HEIGHT */}
                {(this.props.height == undefined &&
                  this.props.height != "auto") ||
                  (this.props.height &&
                    this.props.width !== " " &&
                    this.props.imageWidthUnit !== "%" && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                        }}
                      >
                        <label>Image Height </label>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            width: "100%",
                          }}
                        >
                          <div style={{ width: "120%" }}>
                            <RangeInputSlider
                              onChangeHandler={(widthVal) => {
                                this.rangeHeightSlider(widthVal);
                              }}
                              widthValue={
                                this.props.height == "auto"
                                  ? 0
                                  : this.props.height
                              }
                              maxWidthRange={1200}
                            />
                          </div>
                          <span className="widthRangeLabel">
                            <input
                              onChange={(e) => {
                                this.counterChange(e, "height");
                              }}
                              value={
                                this.props.height == "auto"
                                  ? "auto"
                                  : this.props.height
                              }
                              type="text"
                            />
                          </span>
                        </div>
                      </div>
                    ))}
                {/* HEIGHT ENDS */}
                <div className="clearfix"></div>
                <div className="col-sm-3" style={{ padding: "0" }}>
                  <label>
                    Width <small>100%</small>
                  </label>
                  <input
                    className="checkMark"
                    type="checkbox"
                    id="widthPercentage"
                    name="percentage"
                    value="percentage"
                    onChange={(e) => {
                      this.widthToggle(e, "maxWidth");
                    }}
                    checked={this.props.width == "" ? true : false}
                  />
                  <label htmlFor="widthPercentage"></label>
                </div>
              </div>
            </ImageSetting>
          </Popup>
        )}

        {this.state.clickedImageID === this.props.ID ? (
          <Library
            selectingContent={true}
            initP={this.props.initP}
            ID={this.props.ID}
            srcID={this.props.srcID}
            userID={this.props.userID}
            sessionID={this.props.sessionID}
            imageTab={true}
            toggleUploadPopup={() => {
              this.toggleUploadPopup(null);
            }}
            opacity={this.props.opacity}
            radius={this.props.radius}
            float={this.props.float}
          />
        ) : null}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    layoutTitle: state.present.layoutTitle,
    containerWidth: state.present.containerWidth,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Image);
